<template>
  <div>
    <!-- 麵包屑導航 -->
    <nav class="breadcrumb">
      <span @click="navigateToPage('home')" class="breadcrumb-item">首頁</span>
      <span class="breadcrumb-separator">></span>
      <span class="breadcrumb-item active">搜尋結果</span>
    </nav>

    <div class="all-tools-page">
      <div class="sidebar">
        <h1>搜尋結果</h1>
        <p class="result-count">共 {{ filteredTools.length }} 筆資料</p>
        <input
          type="text"
          placeholder="搜尋工具..."
          class="search-bar"
          v-model="searchQuery"
          @input="filterTools"
        />
        <div class="filters">
          <h2>篩選條件</h2>
          <div class="filter-tags">
            <button
              class="filter-tag"
              v-for="tag in displayedUseCases"
              :key="tag"
              :class="{ active: activeTags.includes(tag) }"
              @click="toggleTag(tag)"
            >
              {{ tag }}
            </button>
          </div>
        </div>
      </div>

      <div class="tools-container">
        <div class="tools-list">
          <div
            class="tool-card"
            v-for="tool in displayedTools"
            :key="tool.toolId"
            @click="navigateToDetail(tool.toolId)"
          >
            <div class="tool-top-border"></div>
            <div class="tool-content">
              <div class="tool-header">
                <h3 class="tool-name">{{ tool.name }}</h3>
                <span class="tool-recommend">推薦: {{ tool.recommend }}</span>
              </div>
              <p class="tool-description">{{ tool.description }}</p>
              <div class="tool-tags">
                <span
                  class="tool-tag"
                  v-for="useCase in tool.relatedUseCases"
                  :key="useCase"
                >
                  #{{ useCase }}
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="load-more">
          <button
            v-if="hasMore"
            class="load-more-button"
            @click="loadMore"
          >
            看更多
          </button>
        </div>
      </div>
    </div>
  </div>
</template>



<script>
import axios from "axios";

export default {
  name: "SearchAll",
  data() {
    return {
      tools: [], // 全部工具數據
      displayedTools: [], // 當前顯示的工具
      searchQuery: "", // 搜尋框的輸入內容
      allUseCases: [], // 全部標籤
      displayedUseCases: [], // 根據顯示的工具動態更新的標籤
      activeTags: [], // 已選中的標籤
      itemsPerPage: 6, // 每次顯示的工具數量
      currentCount: 6, // 當前顯示的工具數量
      filteredTools: [], // 篩選後的工具數據
    };
  },
  computed: {
    hasMore() {
      return this.currentCount < this.filteredTools.length; // 判斷是否還有更多工具可顯示
    },
  },
  methods: {
    navigateToPage(page) {
      if (page === "home") {
        this.$router.push({ name: "Home" });
      }
    },
    async fetchSearchResults(keyword) {
      try {
        const baseUrlo = process.env.VUE_APP_SERVICE_URL;
        const baseUrl = process.env.VUE_APP_BASE_URL || `${baseUrlo}/api/v1`;
        const response = await axios.get(`${baseUrl}/searchMaster/${keyword}`);
        if (response.data.rtnCode === "0000") {
          this.tools = response.data.data.map((tool) => ({
            toolId: tool.toolId || tool.codeno,
            name: tool.name,
            description: tool.description || "無描述資訊",
            recommend: tool.recommend,
            relatedUseCases: tool.relatedUseCases || [],
          }));
          this.filteredTools = [...this.tools];
          this.updateDisplayedTools();
        } else {
          this.filteredTools = [];
          console.error("搜尋失敗：", response.data.rtnMsg);
        }
      } catch (error) {
        console.error("API 請求失敗：", error);
        this.filteredTools = [];
      }
    },
    updateDisplayedTools() {
      this.displayedTools = this.filteredTools.slice(0, this.currentCount);
      this.updateDisplayedUseCases();
    },
    updateDisplayedUseCases() {
      const useCaseCount = {};
      this.displayedTools.forEach((tool) => {
        tool.relatedUseCases.forEach((useCase) => {
          if (useCase in useCaseCount) {
            useCaseCount[useCase]++;
          } else {
            useCaseCount[useCase] = 1;
          }
        });
      });
      this.displayedUseCases = Object.keys(useCaseCount).slice(0, 10);
    },
    loadMore() {
      this.currentCount += this.itemsPerPage;
      this.updateDisplayedTools();
    },
    filterTools() {
      const query = this.searchQuery.toLowerCase();
      this.filteredTools = this.tools.filter(
        (tool) =>
          tool.name.toLowerCase().includes(query) ||
          tool.description.toLowerCase().includes(query)
      );
      this.currentCount = this.itemsPerPage;
      this.updateDisplayedTools();
    },
    toggleTag(tag) {
      if (this.activeTags.includes(tag)) {
        this.activeTags = this.activeTags.filter((activeTag) => activeTag !== tag);
      } else {
        this.activeTags.push(tag);
      }
      this.applyFilters();
    },
    applyFilters() {
      if (this.activeTags.length === 0) {
        this.filteredTools = [...this.tools];
      } else {
        this.filteredTools = this.tools.filter((tool) =>
          this.activeTags.every((tag) => tool.relatedUseCases.includes(tag))
        );
      }
      this.currentCount = this.itemsPerPage;
      this.updateDisplayedTools();
    },
    navigateToDetail(id) {
      this.$router.push({ name: "CardDetail", params: { id } });
    },
  },
  mounted() {
    const keyword = this.$route.params.keyword;
    if (keyword) {
      this.searchQuery = keyword;
      this.fetchSearchResults(keyword);
    }
  },
  watch: {
    "$route.params.keyword"(newKeyword) {
      this.searchQuery = newKeyword;
      this.fetchSearchResults(newKeyword);
    },
  },
};
</script>


<style scoped>
/* 麵包屑樣式 */
.breadcrumb {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #555;
  margin-bottom: 0px; /* 與主內容分開 */
  padding: 30px 20px; /* 增加左右內邊距 */
  
 
}

.breadcrumb-item {
  cursor: pointer;
  color: #000;
  margin-right: 5px;
}

.breadcrumb-item.active {
  cursor: default;
  color: #246531;
  font-weight: bold;
}

.breadcrumb-separator {
  margin-right: 5px;
  color: #888;
}

/* 樣式與上例一致 */
.all-tools-page {
  display: grid;
  grid-template-columns: 1fr 3fr; /* 左側1/4 右側3/4 */
  gap: 20px;
  padding: 20px;
  background-color: #f9f9f9;
}

.sidebar {
  flex: 1;
  max-width: 100%;
  
}

.search-bar {
  width: 100%;
  padding: 10px;
  margin-bottom: 20px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.filters h2 {
  margin-bottom: 10px;
  font-weight: bold;
}

.filter-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.filter-tag {
  padding: 5px 10px;
  background-color: #eef1f6;
  border-radius: 16px;
  border: 1px solid #d1d5db;
  cursor: pointer;
  transition: background-color 0.3s, color 0.3s;
}

.filter-tag.active {
  background-color: #3b82f6;
  color: #ffffff;
  border-color: #3b82f6;
}

.filter-tag:hover {
  background-color: #cbd5e1;
}

/* 工具列表 */
.tools-list {
  display: grid;
  grid-template-columns: repeat(3, 1fr); /* 每排 3 列，均分 */ /* 最小寬度300px，隨剩餘寬度自適應 */
  gap: 15px; /* 縮小縫隙 */
  width: 100%; /* 保證列表區域全寬 */
  padding: 10px;
  box-sizing: border-box; /* 包括內邊距計算寬度 */
}

.tool-card {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 100%; /* 滿格寬度 */
  max-width: none; /* 限制最大寬度，避免卡片過寬 */
  height: auto; /* 高度自適應 */
  padding: 15px;
  background-color: #ffffff;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  box-sizing: border-box;
  transition: transform 0.3s, box-shadow 0.3s;
  cursor: pointer;
  overflow: hidden;
}

.tool-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
}



.tool-top-border {
  height: 5px;
  background-color: #045d19;
  width: 100%;
  border-radius: 8px 8px 0 0;
}

.tool-content {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
}

.tool-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.tool-name {
  font-size: 18px;
  font-weight: bold;
  color: #333;
  max-width: 70%; /* 限制最大寬度，防止與推薦度重疊 */
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.tool-recommend {
  font-size: 14px;
  color: #555;
}
.tool-content {
  display: flex;
  flex-direction: column;
  justify-content: flex-start; /* 從上到下排列 */
  align-items: stretch;
  flex-grow: 1;
  width: 100%;
}

.tool-description {
  font-size: 14px;
  color: #666;
  margin-bottom: 10px; /* 與標籤保持一定距離 */
  min-height: 100px; /* 固定高度，確保留空間給簡介 */
  max-height: 100px; /* 最大顯示高度 */
  display: -webkit-box;
  -webkit-line-clamp: 5; /* 最多顯示 5 行 */
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}


.tool-tags {
  display: flex;
  flex-wrap: wrap; /* 允許換行 */
  gap: 8px;
  align-items: flex-start; /* 從上往下排列 */
  justify-content: flex-start; /* 標籤從左對齊 */
  margin-top: 20px; /* 增加與簡介區域的距離 */
  max-height: 64px; /* 限制標籤區域為兩行 */
  overflow: hidden; /* 隱藏多餘標籤 */
}




.tool-tag {
  font-size: 12px;
  background-color: #eef1f6;
  color: #095bd2;
  padding: 4px 8px;
  border-radius: 4px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.load-more {
  text-align: center; /* 居中對齊 */
  margin-top: 20px; /* 與工具列表保持距離 */
}

.load-more-button {
  padding: 10px 20px;
  background-color: #3b82f6;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.load-more-button:hover {
  background-color: #2563eb;
}

.load-more-button:disabled {
  background-color: #d1d5db;
  cursor: not-allowed;
}

.all-tools-page {
  display: grid;
  grid-template-columns: 1fr 3fr; /* 左側1/4 右側3/4 */
  gap: 20px;
  padding: 20px;
  background-color: #f9f9f9;
  position: relative; /* 必須設置為相對定位 */
}
@media (max-width: 768px) {
  .all-tools-page {
    display: flex;
    flex-direction: column; /* 改為垂直排列 */
    gap: 20px;
    padding: 10px; /* 減少邊距 */
  }

  .sidebar {
    width: 100%; /* 填滿頁面寬度 */
    order: 1; /* 保持在工具上面顯示 */
  }

  .tools-container {
    order: 2; /* 保持在搜尋結果下面顯示 */
  }

  .tools-list {
    grid-template-columns: repeat(1, 1fr); /* 手機上每排顯示一張卡片 */
  }

  .tool-card {
    height: auto; /* 自適應內容高度 */
  }

  .filters {
    flex-wrap: wrap; /* 標籤按行排列 */
    gap: 8px; /* 調整標籤間距 */
  }

  .filter-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 10px; /* 確保標籤在窄屏時排列整齊 */
  }

  .load-more {
    margin-top: 10px; /* 減少距離 */
  }
}

</style>
 
